const StyleA = () => {
  return (
    <div className="style-a">
      <style>{`
        .style-a {
          --bg-primary: #ffffff;
          --bg-secondary: #fafafa;
          --text-primary: #000000;
          --text-secondary: #4a4a4a;
          --accent: #d4af37;
          --border: #e5e5e5;
        }
        
        .style-a.dark {
          --bg-primary: #1a1a1a;
          --bg-secondary: #262626;
          --text-primary: #ffffff;
          --text-secondary: #a0a0a0;
          --accent: #f4d03f;
          --border: #333333;
        }

        .style-a {
          background: var(--bg-primary);
          color: var(--text-primary);
          font-family: 'Inter', sans-serif;
          line-height: 1.7;
          letter-spacing: 0.01em;
        }
        
        .style-a h1, .style-a h2, .style-a h3 {
          font-family: Georgia, serif;
          font-weight: 400;
          letter-spacing: -0.02em;
          margin-bottom: 1.5rem;
        }
        
        .style-a h1 {
          font-size: 3.5rem;
          line-height: 1.1;
          margin-bottom: 2rem;
        }
        
        .style-a h2 {
          font-size: 2.5rem;
          line-height: 1.2;
          color: var(--text-secondary);
        }
        
        .style-a .section {
          margin-bottom: 4rem;
          padding: 3rem 0;
        }
        
        .style-a .card {
          background: var(--bg-secondary);
          border: 1px solid var(--border);
          padding: 3rem;
          margin-bottom: 2rem;
        }
        
        .style-a .accent-text {
          color: var(--accent);
          font-weight: 500;
        }
        
        .style-a .button-primary {
          background: var(--text-primary);
          color: var(--bg-primary);
          border: 2px solid var(--text-primary);
          padding: 1rem 2rem;
          font-weight: 500;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          transition: all 0.3s ease;
        }
        
        .style-a .button-primary:hover {
          background: transparent;
          color: var(--text-primary);
        }
      `}</style>
      
      <div className="max-w-4xl mx-auto px-8 py-12">
        <header className="section text-center">
          <h1>Academic Minimal</h1>
          <p className="text-xl" style={{color: 'var(--text-secondary)', maxWidth: '600px', margin: '0 auto'}}>
            Museum exhibition-inspired design emphasizing readability, 
            scholarly precision, and timeless elegance.
          </p>
        </header>

        <section className="section">
          <div className="card">
            <h2>Collections Management</h2>
            <p style={{color: 'var(--text-secondary)', marginBottom: '1.5rem'}}>
              Our approach to digital collections mirrors the careful attention of museum curators. 
              Every item is cataloged with <span className="accent-text">scholarly precision</span>, 
              ensuring that cultural heritage materials are preserved with the respect they deserve.
            </p>
            <p style={{color: 'var(--text-secondary)'}}>
              We believe that good design, like good scholarship, should be 
              <em>invisible</em> — serving the content rather than competing with it.
            </p>
          </div>
        </section>

        <section className="section">
          <h2 style={{textAlign: 'center', marginBottom: '3rem'}}>Design Principles</h2>
          
          <div style={{display: 'grid', gap: '2rem', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))'}}>
            <div className="card" style={{textAlign: 'center'}}>
              <h3>Generous Whitespace</h3>
              <p style={{color: 'var(--text-secondary)'}}>
                Like gallery walls, our layouts provide breathing room for ideas to resonate.
              </p>
            </div>
            
            <div className="card" style={{textAlign: 'center'}}>
              <h3>Typographic Hierarchy</h3>
              <p style={{color: 'var(--text-secondary)'}}>
                Clear information structure guides readers through complex material.
              </p>
            </div>
            
            <div className="card" style={{textAlign: 'center'}}>
              <h3>Restrained Palette</h3>
              <p style={{color: 'var(--text-secondary)'}}>
                Color serves meaning, not decoration. Every accent has purpose.
              </p>
            </div>
          </div>
        </section>

        <section className="section text-center">
          <h2>Scholarly Excellence</h2>
          <p style={{color: 'var(--text-secondary)', maxWidth: '600px', margin: '0 auto 2rem'}}>
            This aesthetic speaks to institutions that value tradition, scholarship, 
            and the careful preservation of cultural knowledge.
          </p>
          <button className="button-primary">
            Explore This Approach
          </button>
        </section>
      </div>
    </div>
  );
};

export default StyleA;